<template>
  <nav v-if="role == 'booster'">
    <v-textarea
      dense
      outlined
      disabled
      class="survey-open-textarea rounded-lg pa-0 ma-0 mt-3 text-body-2 mx-auto"
      :placeholder="$t('surveyTextareaParticipantPlaceholder')"
      data-testid="open-textarea"
    />
    <v-icon class="float-left" data-testid="attachment-icon">
      mdi-paperclip
    </v-icon>
  </nav>
  <nav v-else>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-textarea
      v-model="answer"
      dense
      outlined
      class="survey-open-textarea rounded-lg pa-0 ma-0 mt-3 text-body-2 mx-auto"
      data-testid="open-textarea"
      hide-details
      @change="answerQuestion"
    />
    <v-file-input
      v-model="fileData"
      data-testid="attachment-icon"
      hide-input
      :disabled="attachmentsCount == 1 || loadingUpload"
      class="pt-0 pb-3 float-left"
      accept="image/png, image/jpeg, .pdf, .ppt, .pptx, .doc, .docx, .xls, .xlsx, .odt, .csv, .ods, .rtf, .txt"
      @change="uploadFile"
    />
    <v-card
      v-for="(itemAttachment, index) in attachments"
      :key="index"
      class="attachment-container mr-3 rounded-lg d-flex align-items-center justify-content-center elevation-2"

    >
      <v-row no-gutters class="pa-1">
        <v-col cols="10" sm="11" class="align-self-center d-flex">
          <span
            :style="`color: ` + itemAttachment.ext.color"
            :class="`mdi mdi-24px ` + itemAttachment.ext.icon"
            >&nbsp;</span
          >
          <v-clamp autoresize :max-lines="1" class="text-caption align-self-center">
            {{ itemAttachment.title }}
          </v-clamp>
        </v-col>
        <v-col cols="2" sm="1" class="align-self-center">
          <v-btn
            data-testid="delete-attachment-button"
            icon
            small
            class=""
            @click.stop="removeFileSurvey(itemAttachment)"
          >
            <v-icon small color="black"> mdi-close </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <p v-if="showError" class="error--text font-italic pt-3" :class="attachments.length > 0 ? '' : 'mt-11'">
      {{ $t("answerError") }}
    </p>
  </nav>
</template>
<script>
import i18n from "../../../../plugins/i18n";
import { removeFileSurvey, uploadFileSurvey } from "../../../../api/activityApi";
import VClamp from "vue-clamp";
import AlertMessages  from '../../../AlertMessages'

export default {
  components: {
    VClamp,
    AlertMessages
  },
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    role: {
      type: String,
      default: "booster",
    },
    invalidAnswers: {
      type: Array,
      default: () => [],
    },
    hasSubmittedSurvey: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      answer: "",
      answerObject: {
        type: this.question.type,
        id: this.question.id,
        answer: "",
        attachment: null,
      },
      showError: false,
      alertMsg: "",
      alertType: "",
      alertValue: false,
      loadingData: false,
      loadingUpload: false,
      attachments: [],
      fileData: null,
      spaceId: window.$cookies.get("space_id"),
      attachmentIcons: [
        { type: "jpeg", color: "#00C853", icon: "mdi-file-jpg-box" },
        { type: "jpg", color: "#00C853", icon: "mdi-file-jpg-box" },
        { type: "png", color: "#2962FF", icon: "mdi-file-png-box" },
        { type: "pdf", color: "#ff1744", icon: "mdi-file-pdf-box" },
        { type: "ppt", color: "#FBC02D", icon: "mdi-file-powerpoint-outline" },
        { type: "pptx", color: "#FBC02D", icon: "mdi-file-powerpoint-outline" },
        { type: "doc", color: "#2979FF", icon: "mdi-file-document-outline" },
        { type: "docx", color: "#2979FF", icon: "mdi-file-document-outline" },
        { type: "xls", color: "#00C853", icon: "mdi-file-excel-outline" },
        { type: "xlsx", color: "#00C853", icon: "mdi-file-excel-outline" },
        { type: "odt", color: "#2979FF", icon: "mdi-file-document-outline" },
        { type: "csv", color: "#00C853", icon: "mdi-file-delimited-outline" },
        { type: "ods", color: "#00C853", icon: "mdi-file-excel-outline" },
        { type: "rtf", color: "#7C8386", icon: "mdi-file-document-outline" },
        { type: "txt", color: "#7C8386", icon: "mdi-file-document-outline" },
      ],
      attachmentIcon: {},
      attachmentExtension: "",
    };
  },
  computed: {
    attachmentsCount() {
      return this.attachments.length;
    },
  },
  created() {
    this.$emit("sendAnswer", this.answerObject);
  },
  watch: {
    invalidAnswers() {
      this.showError = false;
      if (
        this.hasSubmittedSurvey &&
        this.invalidAnswers.includes(this.question.id)
      ) {
        this.showError = true;
      }
    },
  },
  methods: {
    answerQuestion() {
      this.answerObject.answer = this.answer;
      this.answerObject.attachment = this.attachment;
      this.$emit("sendAnswer", this.answerObject);
    },
    loading() {
      if (this.loadingUpload || this.buttonDisabled) {
        return true;
      }
      return false;
    },
    async uploadFile() {
      if (this.attachmentsCount >= 1) {
        return false;
      }
      if (this.fileData) {
        if (this.fileData.size > 5 * 1024 * 1024) {
          this.alertMsg = i18n.t("uploadAttachmentSizeError");
          this.alertValue = true;
          this.alertType = "error";
        } else {
          this.loadingUpload = true;
          try {
            let data = new FormData();
            data.append("type", "survey_attachment");
            data.append("file", this.fileData);
            data.append("space_id", this.spaceId);
            data.append("question", this.question.id);

            const response = await uploadFileSurvey(
              this.$route.params.surveyId,
              data
            );
            if (response.status == 200) {
              this.attachment = response.data.meta.detail;
              var attachmentslist = response.data;
              this.attachmentExtension = response.data.meta.title
                .split(".")
                .pop();
              this.attachmentIcon =
                this.attachmentIcons[
                  this.attachmentIcons.findIndex(
                    (item) => item.type == this.attachmentExtension
                  )
                ];
              this.attachments.push({
                title: attachmentslist.meta.title,
                ext: this.attachmentIcon,
                detail: attachmentslist.meta.detail,
              });
              this.loadingUpload = false;
            }
          } catch (e) {
            if (e.response.status == 422) {
              for (let i = 0; i < e.response.data.errors.length; i++) {
                this.alertValue = true;
                this.alertType = "error";
                if (
                  e.response.data.errors[i].meta[0].code ==
                  "extensionUnsupported"
                ) {
                  this.alertMsg = i18n.t("uploadDocumentExtensionError");
                } else {
                  this.alertMsg = i18n.t("serverError");
                }
              }
            } else if (e.response.status == 403) {
              for (let i = 0; i < e.response.data.errors.length; i++) {
                if (e.response.data.errors[i].detail == "Storage is full") {
                  this.alertValue = true;
                  this.alertType = "error";
                  this.alertMsg = i18n.t("storageFullError");
                } else {
                  this.$router.push({ name: "PageAccessDenied" });
                }
              }
            } else {
              this.alertValue = true;
              this.alertType = "error";
              this.alertMsg = i18n.t("serverError");
            }
            this.loadingUpload = false;
          }
        }
        this.answerQuestion();
      }
    },
     async removeFileSurvey(item){
            try {
                let data = {
                  data: {
                      type: "thread-files", 
                      attributes: {
                          path: item.detail
                      },
                  }
                }
                const response = await removeFileSurvey(this.$route.params.surveyId, data) 
                if(response.status == 200) {
                      this.attachments = this.attachments.filter(attachment => attachment.detail != item.detail)
                      this.attachment = null
                }
            }catch(e){
                this.alertValue = true
                this.alertType = 'error'
                this.alertMsg =  i18n.t('serverError')
            }
            this.answerQuestion();
            
    }
    
  },
};
</script>